import { render, staticRenderFns } from "./ChatbotPreview.vue?vue&type=template&id=acf52058"
import script from "./ChatbotPreview.vue?vue&type=script&lang=js"
export * from "./ChatbotPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports